import { j as t } from "../../chunks/jsx-runtime.DGlMoOmv.js";
import * as Z from "react";
import { B as x } from "../../chunks/Button.Ccj-dDdM.js";
import { h as v, b as p, i as $, f as j, D as q, e as J, a as K, I as Q } from "../../chunks/ItemV2Title.R5KRywzn.js";
import { j as xt, c as vt, d as pt, g as jt, k as It } from "../../chunks/ItemV2Title.R5KRywzn.js";
import { F as W } from "../../chunks/ChevronRight20.XQ503sZW.js";
import { F as tt } from "../../chunks/MoreHorizontal20.D_05FUdz.js";
import { c as I } from "../../chunks/index.CxSWpsOB.js";
import { c as et } from "../../chunks/index.C4-GUKyp.js";
import { I as rt } from "../../chunks/InlineBullets.BoW_Cy1W.js";
import { n as at } from "../../chunks/MediaTile.DaLJeauY.js";
import { I as zt } from "../../chunks/ItemGroup.BoGmhka9.js";
const nt = et(["tw-group/item-v2 tw-flex tw-flex-wrap tw-items-center tw-gap-12 tw-rounded-8 tw-border-2 tw-text-left tw-outline-none tw-transition-colors tw-duration-100", "focus-visible:tw-border-ring focus-visible:tw-ring-ring/50 focus-visible:tw-ring-[3px]"].join(" "), {
  variants: {
    variant: {
      ghost: ["tw-bg-transparent tw-border-transparent", "hover:tw-bg-gray-200 [a]:hover:tw-bg-gray-200 [button]:hover:tw-bg-gray-200"].join(" "),
      outline: ["tw-bg-base-white tw-border tw-border-solid tw-border-gray-400", "hover:tw-bg-gray-200 [a]:hover:tw-bg-gray-200 [button]:hover:tw-bg-gray-200"].join(" "),
      highlight: [
        // Gradient border (brand-gradient-1) painted as a layered background:
        //   layer 1 (padding-box): the inner fill, driven by `--gradient-inner-bg`
        //   layer 2 (border-box): the brand purple gradient (135deg)
        // Hex values match `purple-100` (#F9F7FD) and `purple-200` (#F3EEFD);
        // gradient stops match `brand.gradient-1` in `color-primitives.ts`.
        "tw-border-transparent",
        "[background-image:linear-gradient(var(--gradient-inner-bg,#ffffff),var(--gradient-inner-bg,#ffffff)),linear-gradient(135deg,#6C30D1,#A930D1)]",
        "[background-origin:border-box]",
        "[background-clip:padding-box,border-box]",
        "[--gradient-inner-bg:#F9F7FD]",
        "hover:[--gradient-inner-bg:#F3EEFD]",
        "[a]:hover:[--gradient-inner-bg:#F3EEFD]",
        "[button]:hover:[--gradient-inner-bg:#F3EEFD]"
      ].join(" "),
      critical: [
        // Alert/critical row: red-100 fill with a solid red-800 outline.
        "tw-bg-red-100 tw-border tw-border-solid tw-border-red-800",
        "hover:tw-bg-red-200 [a]:hover:tw-bg-red-200 [button]:hover:tw-bg-red-200"
      ].join(" ")
    },
    size: {
      xs: "tw-p-0",
      sm: "tw-p-8",
      md: "tw-p-12",
      lg: "tw-p-16"
    },
    disabled: {
      true: "tw-pointer-events-none tw-opacity-60",
      false: ""
    }
  },
  defaultVariants: {
    variant: "ghost",
    size: "md",
    disabled: !1
  }
}), E = "tw-min-w-0 tw-w-full tw-max-w-full tw-line-clamp-2", z = "tw-min-w-0 tw-w-full tw-max-w-full tw-line-clamp-3", F = (e) => typeof e == "string" ? e : /* @__PURE__ */ t.jsx(rt, { items: [...e] }), it = ({
  badge: e,
  description: r,
  secondaryDescription: a,
  title: s,
  typographyScale: n
}) => /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
  e != null ? /* @__PURE__ */ t.jsxs("div", { "data-slot": "item-v2-title-row", className: "tw-flex tw-min-w-0 tw-w-full tw-flex-wrap tw-items-start tw-gap-4 tw-flex-1", children: [
    /* @__PURE__ */ t.jsx("div", { className: "tw-min-w-0 tw-flex-1", children: /* @__PURE__ */ t.jsx(v, { className: E, contentSize: n, children: s }) }),
    /* @__PURE__ */ t.jsx("div", { className: "tw-flex tw-shrink-0 tw-items-center", children: e })
  ] }) : /* @__PURE__ */ t.jsx(v, { className: E, contentSize: n, children: s }),
  r != null && (Array.isArray(r) ? r.length > 0 : r !== "") && /* @__PURE__ */ t.jsx(p, { className: z, contentSize: n, children: F(r) }),
  a != null && (Array.isArray(a) ? a.length > 0 : a !== "") && /* @__PURE__ */ t.jsx(p, { className: z, contentSize: n, variant: "secondary", children: F(a) })
] }), T = Z.forwardRef(({
  avatar: e,
  avatarAlt: r = "",
  badge: a,
  buttonIcon: s,
  buttonLabel: n,
  buttonOnClick: w,
  className: V,
  contentSize: y,
  description: C,
  disabled: i = !1,
  expanded: o,
  icon: g,
  media: M,
  mediaAlt: N = "",
  mediaSize: A,
  moreIcon: _,
  moreLabel: D,
  moreOnClick: u,
  onClick: S,
  secondaryDescription: k,
  size: b = "md",
  style: R,
  title: B,
  variant: m = "ghost"
}, L) => {
  const c = $[y ?? "md"], d = A ?? q, f = at(M), P = f != null || g != null, h = m !== "ghost" && b === "xs" ? "sm" : b, O = s ?? /* @__PURE__ */ t.jsx(W, { className: I("tw-transition-transform tw-duration-100", o === !0 && "-tw-rotate-90", o === !1 && "tw-rotate-90") }), U = n ?? (o === !0 ? "Collapse" : o === !1 ? "Expand" : "Open"), Y = _ ?? /* @__PURE__ */ t.jsx(tt, {}), G = D ?? "More options", l = S ?? w, H = (X) => {
    l == null || i || X.target.closest('[data-slot="item-v2-actions"]') || l();
  };
  return /* @__PURE__ */ t.jsxs("div", { ref: L, "data-slot": "item-v2", "data-variant": m, "data-size": h, "data-content-size": c, "aria-disabled": i || void 0, onClick: l != null ? H : void 0, style: R, className: I(nt({
    variant: m,
    size: h,
    disabled: i,
    className: V
  }), l != null && !i && "tw-cursor-pointer"), children: [
    P && (f != null ? /* @__PURE__ */ t.jsx(j, { alt: N, avatar: e, avatarAlt: r, media: f, size: d === 24 ? 40 : d, variant: "image" }) : /* @__PURE__ */ t.jsx(j, { size: d, variant: "icon", children: g })),
    /* @__PURE__ */ t.jsxs(J, { children: [
      /* @__PURE__ */ t.jsx(K, { contentSize: c, children: /* @__PURE__ */ t.jsx(it, { badge: a, description: C, secondaryDescription: k, title: B, typographyScale: c }) }),
      /* @__PURE__ */ t.jsxs(Q, { children: [
        u != null && /* @__PURE__ */ t.jsx(x, { type: "button", variant: "ghost", shape: "circle", size: "default", iconOnly: !0, disabled: i, "aria-label": G, onClick: u, children: Y }),
        w != null && /* @__PURE__ */ t.jsx(x, { type: "button", variant: "ghost", shape: "circle", size: "default", iconOnly: !0, disabled: i, "aria-label": U, "aria-expanded": o !== void 0 ? o : void 0, onClick: w, children: O })
      ] })
    ] })
  ] });
});
T.displayName = "Item";
const ut = T;
export {
  q as DEFAULT_ITEM_MEDIA_PX,
  $ as ITEM_CONTENT_SIZE_TO_TYPOGRAPHY_SCALE,
  xt as ITEM_V2_TITLE_TYPEFACE,
  T as Item,
  zt as ItemGroup,
  ut as ItemV2,
  Q as ItemV2Actions,
  K as ItemV2Content,
  p as ItemV2Description,
  vt as ItemV2Footer,
  pt as ItemV2Header,
  J as ItemV2Main,
  j as ItemV2Media,
  jt as ItemV2Separator,
  v as ItemV2Title,
  It as itemV2DescriptionTypeface,
  at as normalizeItemV2MediaUrls
};
//# sourceMappingURL=index2.js.map
